<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image_text"><div class="image_text" style="width:56%"><img alt="e9781439627877_i0003.jpg" src="images/e9781439627877_i0003.jpg"/></div>
<div class="caption"><p class="p"><span>“Greetings from Pontiac” is a card from the 1940s. Besides a generalized Indian profile—no true likenesses of Chief Pontiac are known—we see portions of the Peoples State Bank, the Pontiac plant, the courthouse, St. Joseph’s Mercy Hospital, Orchard Lake, the Fisher Body plant, and Cranbrook School for Boys—the latter actually was located in neighboring Bloomfield Hills.</span></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439627877_fm02.vue?cca7fc36